export default __webpack_public_path__ + "images/11_2_image.jpg";